<template>
  <div class="z-cell-group">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'z-cell-group'
};
</script>



// WEBPACK FOOTER //
// cell-group.vue?ba6d534c